<fc-progress-bar currentStep="1" *ngIf="!readOnlyMap && !isAdmin"></fc-progress-bar>
<div class="container">
  <div class="main">
    <ng-container *ngIf="activeSite">
      <fc-locate-map [drawer]="drawer"></fc-locate-map>
    </ng-container>
  </div>

  <mat-drawer-container [ngClass]="drawer.opened ? 'opened' : 'closed'" hasBackdrop="false">
    <mat-drawer #drawer mode="side" opened="false" position="end">
      <div (click)="drawer.toggle()" *ngIf="!router.url.includes('eligibility-check')" class="toggle-button">
        <fa-icon *ngIf="!drawer.opened" [icon]="['fas', 'chevron-left']"></fa-icon>
        <fa-icon *ngIf="drawer.opened" [icon]="['fas', 'chevron-right']"></fa-icon>
      </div>
      <div class="side-panel">
        <ng-container *ngIf="activeSite">
          <router-outlet (activate)="onOutletLoaded($event)"></router-outlet>
        </ng-container>
      </div>
    </mat-drawer>
  </mat-drawer-container>
</div>
